import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import BudgetCalculator from './components/BudgetCalculator';

export default function ContactosPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navegação */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/821bfe14b1fc609bf2a57dd541a10a42.png" 
                alt="FF TRAVEL - Agência de Viagens" 
                className="h-32 md:h-36"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Início
              </Link>
              <Link to="/agencia-viagens" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Agência de Viagens
              </Link>
              <Link to="/loja-servicos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Loja & Serviços
              </Link>
              <Link to="/sobre" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Sobre
              </Link>
              <Link to="/contactos" className="text-[#ff6b35] font-semibold">
                Contactos
              </Link>
            </div>

            <a 
              href="https://wa.me/244936769113" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden md:block bg-[#ff6b35] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff5722] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Pedir Cotação
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff6b35] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center text-white animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-slide-up">
              Entre em Contacto
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: '0.2s' }}>
              Estamos prontos para ajudá-lo a realizar a sua próxima viagem
            </p>
          </div>
        </div>
      </section>

      {/* Informações de Contacto */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all">
              <div className="w-16 h-16 bg-[#1e40af]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-phone-line text-3xl text-[#1e40af]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-4">Telefone</h3>
              <a href="tel:+244936769113" className="block text-gray-600 hover:text-[#ff6b35] transition-colors mb-2 cursor-pointer">
                +244 936 769 113
              </a>
              <a href="tel:+244927606910" className="block text-gray-600 hover:text-[#ff6b35] transition-colors cursor-pointer">
                +244 927 606 910
              </a>
            </div>

            <div className="text-center p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all">
              <div className="w-16 h-16 bg-[#1e40af]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-map-pin-line text-3xl text-[#1e40af]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-4">Localização</h3>
              <p className="text-gray-600">
                Rua do Campo do Escoqueiro<br />
                De frente ao prédio do Cucu<br />
                Luanda, Angola
              </p>
            </div>

            <div className="text-center p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-all">
              <div className="w-16 h-16 bg-[#1e40af]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-3xl text-[#1e40af]"></i>
              </div>
              <h3 className="text-xl font-bold text-[#1e3a8a] mb-4">Horário</h3>
              <p className="text-gray-600">
                Segunda a Sexta: 08:00 - 17:00<br />
                Sábado: 08:00 - 12:00<br />
                Domingo: Fechado
              </p>
            </div>
          </div>

          {/* Mapa */}
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.5234567890123!2d13.234567890123456!3d-8.838333333333333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNTAnMTguMCJTIDEzwrAxNCcwNC40IkU!5e0!3m2!1spt-PT!2sao!4v1234567890123!5m2!1spt-PT!2sao"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização FF Travel"
            ></iframe>
          </div>
        </div>
      </section>

      {/* Calculadora de Orçamento */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#1e3a8a] mb-6">
              Calcule o Seu Orçamento
            </h2>
            <p className="text-gray-600 text-lg">
              Obtenha uma estimativa rápida para a sua viagem
            </p>
          </div>
          <BudgetCalculator />
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-24 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto para Começar?
          </h2>
          <p className="text-xl text-white/90 mb-10">
            Entre em contacto conosco agora e receba atendimento personalizado
          </p>
          <a 
            href="https://wa.me/244936769113" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-[#ff6b35] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all shadow-2xl whitespace-nowrap cursor-pointer"
          >
            Falar no WhatsApp
          </a>
        </div>
      </section>

      {/* Rodapé */}
      <footer className="bg-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/e349152b587c7809cba7381685cd68b4.png" 
                alt="FF TRAVEL - Agência de Viagens" 
                className="h-32 md:h-36 mb-8"
              />
              <p className="text-white/70 leading-relaxed mb-4">
                FF Prestação & Serviço, Lda
              </p>
              <p className="text-white/50 text-sm mb-6">
                NIF: 500714988
              </p>
              
              {/* Redes Sociais */}
              <div className="mb-6">
                <p className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">
                  Siga-nos
                </p>
                <div className="flex gap-3">
                  <a 
                    href="https://www.instagram.com/ff_travel_angola/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="Instagram"
                  >
                    <i className="ri-instagram-line text-2xl text-white"></i>
                  </a>
                  <a 
                    href="https://www.facebook.com/share/1AVqwyfH7E/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#1877F2] hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="Facebook"
                  >
                    <i className="ri-facebook-fill text-2xl text-white"></i>
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/ff-travel" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-[#0A66C2] hover:scale-110 rounded-xl flex items-center justify-center transition-all shadow-lg cursor-pointer"
                    title="LinkedIn"
                  >
                    <i className="ri-linkedin-fill text-2xl text-white"></i>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Contactos</p>
              <div className="space-y-3">
                <a href="tel:+244936769113" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                  +244 936 769 113
                </a>
                <a href="tel:+244927606910" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                  +244 927 606 910
                </a>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Localização</p>
              <p className="text-white/70 leading-relaxed">
                Rua do Campo do Escoqueiro<br />
                De frente ao prédio do Cucu<br />
                Luanda, Angola
              </p>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Links Rápidos</p>
              <div className="space-y-3">
                <Link to="/" className="block text-white hover:text-[#ff6b35] transition-colors">Início</Link>
                <Link to="/agencia-viagens" className="block text-white hover:text-[#ff6b35] transition-colors">Agência de Viagens</Link>
                <Link to="/loja-servicos" className="block text-white hover:text-[#ff6b35] transition-colors">Loja & Serviços</Link>
                <Link to="/sobre" className="block text-white hover:text-[#ff6b35] transition-colors">Sobre</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2025 FF TRAVEL. Todos os direitos reservados.
            </p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors cursor-pointer text-sm">Powered by Readdy</a>
          </div>
        </div>
      </footer>

      {/* Botão WhatsApp Flutuante */}
      <a 
        href="https://wa.me/244936769113" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse cursor-pointer"
        style={{ boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)' }}
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>
    </div>
  );
}
